import { LOGIN_MIDDLE_PAGE_URI, QQ_APPID } from 'lib/constants/login';
import UrlParams from '../url';
import { config } from 'lib/config';
import { ENV } from 'lib/constants/domain';

interface QQLoginParams {
  appId: string;
  isTest?: boolean;
}

interface WXLoginParams {
  appId: string;
  isTest?: boolean;
  auto?: boolean;
}

const loginByQQConnect = (loginParams: QQLoginParams) => {
  const { appId } = loginParams;
  // 该页面将code换取token，存到cookie中
  const middlePageUrl = LOGIN_MIDDLE_PAGE_URI.QQ;
  const currentPageUrl = location.href;

  const middlePageParams = {
    parent_domain: `${location.protocol}//${location.host}`,
    appid: appId,
    redirectUri: currentPageUrl,
    isTest: Number(config.env === ENV.TEST),
  };
  // 登录成功后回调地址
  const redirectUri = UrlParams.appendUrlParams(middlePageParams, middlePageUrl);

  const loginOpt = {
    client_id: appId,
    redirect_uri: redirectUri,
  };
  location.href = `https://graph.qq.com/oauth2.0/authorize?response_type=code&${UrlParams.appendUrlParams(loginOpt)}`;
};

const getQQLoginUrl = () => {
  const appId = QQ_APPID.PROD;
  // 该页面将code换取token，存到cookie中
  const middlePageUrl = LOGIN_MIDDLE_PAGE_URI.QQ_UNION;

  const middlePageParams = {
    parent_origin: location.origin,
    timestr: new Date().getTime(),
    appid: appId,
    is_test: Number(config.env === ENV.TEST),
  };

  // 登录成功后回调地址
  const redirectUri = UrlParams.appendUrlParams(middlePageParams, middlePageUrl);

  const loginOpt = {
    client_id: appId,
    redirect_uri: redirectUri,
  };
  return `https://graph.qq.com/oauth2.0/show?which=Login&display=pc&response_type=code&${UrlParams.appendUrlParams(loginOpt)}`;
};

const loginByWx = (loginParams: WXLoginParams) => {
  const { appId, auto } = loginParams;
  // 该页面将code换取token，存到cookie中
  const middlePageUrl = LOGIN_MIDDLE_PAGE_URI.WX;
  const currentPageUrl = location.href;

  const middlePagaParams = {
    parent_domain: `${location.protocol}//${location.host}`,
    appid: appId,
    redirectUri: currentPageUrl,
    isTest: Number(config.env === ENV.TEST),
  };
  // 登录成功后回调地址
  const redirectUri = UrlParams.appendUrlParams(middlePagaParams, middlePageUrl);

  // 顺序不可变更，否则可能会导致微信小程序 h5 登录失败
  const loginOpt = {
    appid: appId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: auto ? 'snsapi_base' : 'snsapi_userinfo',
  };

  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?${UrlParams.appendUrlParams(loginOpt)}&state=STATE&#wechat_redirect`;
};

export { loginByQQConnect, loginByWx, getQQLoginUrl };
